import { Controller } from "@hotwired/stimulus"

// Le scelte dei capitolati di Decreto.js (Capitolati, 31a5bd1): per ogni capitolato le righe «Scegli la voce» (con
// «(già sul capitolato a, b)» per le voci usate negli altri), l'importo solo con piu' di una riga («tutto l'ammesso del
// capitolato» con una), «Aggiungi voce», X per toglierle, le proposte gialle (si nascondono quando la voce e' gia' scelta).
// Le scelte restano come le ha scritte l'operatore finche' non conferma o annulla (useEffect su [d.id, confermati.at]):
// quando il server riscrive il blocco, disconnect le annota e connect le rimette se la conferma e' la stessa.
// L'invio manda tutte le righe di tutti i capitolati, nel campo `scelte` (JSON): `importo` come testo solo con piu' righe,
// altrimenti null.
const salvate = new Map()
let navigando = false
// una nuova pagina riparte dal server (il componente si smonta): niente scelte da una visita all'altra
document.addEventListener("turbo:before-render", () => { navigando = true; salvate.clear() })
document.addEventListener("turbo:render", () => { navigando = false })

export default class extends Controller {
  static targets = ["capitolato", "modello", "scelte"]
  static values = { decreto: String, conferma: String }

  connect() {
    const s = salvate.get(this.decretoValue)
    if (s && s.conferma === this.confermaValue) this.ripristina(s.scelte)
    this.aggiorna()
  }

  disconnect() {
    if (navigando) return
    salvate.set(this.decretoValue, { conferma: this.confermaValue, scelte: this.leggi() })
  }

  aggiungi({ currentTarget }) {
    this.aggiungiRiga(currentTarget.closest("[data-codice]"), "", "")
    this.aggiorna()
  }

  proponi({ currentTarget, params: { voce } }) {
    this.aggiungiRiga(currentTarget.closest("[data-codice]"), voce, "")
    this.aggiorna()
  }

  togli({ currentTarget }) {
    currentTarget.closest("[data-riga]").remove()
    this.aggiorna()
  }

  cambia() { this.aggiorna() }

  prepara() {
    const scelte = this.leggi()
    const capitolati = Object.entries(scelte).map(([codice, righe]) => ({
      codice,
      // tutte le righe, anche senza voce: il server dice «riga N senza voce»
      voci: righe.map((r) => ({ voce_id: r.voce_id, importo: righe.length > 1 ? String(r.importo ?? "") : null })),
    }))
    this.scelteTarget.value = JSON.stringify(capitolati)
  }

  righe(cap) { return Array.from(cap.querySelectorAll("[data-riga]")) }

  aggiungiRiga(cap, voce, importo) {
    const riga = this.modelloTarget.content.cloneNode(true)
    riga.querySelector("select").value = voce
    riga.querySelector("[data-importo]").value = importo
    cap.querySelector("[data-righe]").append(riga)
  }

  leggi() {
    const scelte = {}
    this.capitolatoTargets.forEach((cap) => {
      scelte[cap.dataset.codice] = this.righe(cap).map((r) => ({
        voce_id: r.querySelector("select").value, importo: r.querySelector("[data-importo]").value,
      }))
    })
    return scelte
  }

  ripristina(scelte) {
    this.capitolatoTargets.forEach((cap) => {
      const righe = scelte[cap.dataset.codice]
      if (!righe) return
      cap.querySelector("[data-righe]").replaceChildren()
      righe.forEach((r) => this.aggiungiRiga(cap, r.voce_id, r.importo))
    })
  }

  aggiorna() {
    const usate = {}
    this.capitolatoTargets.forEach((cap) => {
      this.righe(cap).forEach((r) => {
        const v = r.querySelector("select").value
        if (v) (usate[v] ||= []).push(cap.dataset.codice)
      })
    })
    this.capitolatoTargets.forEach((cap) => {
      const righe = this.righe(cap)
      righe.forEach((r) => {
        r.querySelector("[data-importo]").hidden = righe.length < 2
        r.querySelector("[data-solo]").hidden = righe.length !== 1
        r.querySelectorAll("option[data-nome]").forEach((o) => {
          const altri = (usate[o.value] || []).filter((k) => k !== cap.dataset.codice)
          o.textContent = o.dataset.nome + (altri.length ? ` (già sul capitolato ${altri.join(", ")})` : "")
        })
      })
      const scelte = righe.map((r) => r.querySelector("select").value)
      cap.querySelectorAll("[data-proposta]").forEach((p) => { p.hidden = scelte.includes(p.dataset.proposta) })
    })
  }
}
